import { findObjectUseCase, upsertUseCase } from "../../../usecases/object";
import { printDisbursementVoucher } from "./PrintDisbursementVoucher/PrintDisbursementVoucher";
import { printComponent } from "nq-component";
import { extractSalary } from "../../../components/common/Converter";
import {
  calculate,
  calculateArray,
} from "../Payroll/helper-payroll/HelperFunction";
import BaseFormPresenter from "../../../base/BaseFormPresenter";
import { sumArray } from "./payrollForm/utils/helperFunction";
import {
  contributions,
  contributionMap,
  payrollBreakdown,
} from "./helper/payrollConstants";
import {
  isAddendumBackPayItem,
  isBackPayItem,
  PAY_ITEMS,
} from "../Payroll/helper-payroll/constants/payrollConstants";
import { caseRegistry } from "./payrollForm/payrollCases/PayrollCasesPage";
import { _sumAmounts, _calculateTax } from "./helper/helperFunction";

class PayrollListFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  _handleNextBtn = () => {
    const dvNumber = this.view.state.dvNumber?.trim();
    if (!dvNumber) {
      this.view
        .showConfirmDialog(
          "Please enter DV No. before proceeding.",
          "DV No. Required",
          "OKAY"
        )
        .catch(() => {});
      return;
    }

    printComponent(this.view.contractPDF.current);
  };

  checkCase = (caseName) => {
    const caseHandler = caseRegistry[caseName];
    const data = this.view.props.objectData;

    // const data = {
    //   payrollType:  "Individual Payroll",
    //   jobType: "Job Order",
    //   payItem: "Last Salary",

    // };
    return typeof caseHandler === "function" ? caseHandler(data) : false;
  };

  _sumAllContributions({ payrollItems, objectData }) {
    const { payItem } = objectData;

    const totalsObj = Object.values(contributions).reduce((acc, key) => {
      acc[key] = 0;
      return acc;
    }, {});

    const getPayrollNetAmount = (payroll) => {
      const { netAmount } = payroll || {};

      let total = 0;

      if (Array.isArray(netAmount)) {
        for (const entry of netAmount) {
          let amount = NaN;

          if (typeof entry === "string" && entry.includes("-")) {
            const [, amountStr] = entry.split("-");
            amount = parseFloat(amountStr?.trim());
          } else if (typeof entry === "number") {
            amount = entry;
          } else if (typeof entry === "string") {
            amount = parseFloat(entry);
          }

          if (!isNaN(amount)) {
            total += amount;
          }
        }
      } else {
        const amount = parseFloat(netAmount);
        if (!isNaN(amount)) {
          total += amount;
        }
      }

      return total;
    };

    const validPayrollItems = payrollItems.filter(
      (payroll) => getPayrollNetAmount(payroll) > 0
    );

    const allContributions = validPayrollItems.flatMap(
      (p) => p.contributions || []
    );

    for (const contribution of allContributions) {
      const [type, rawValues] = contribution.split(":");
      if (!rawValues) continue;

      const totalAmount = _sumAmounts(rawValues);

      for (const key in contributionMap) {
        if (type.includes(key)) {
          totalsObj[contributionMap[key]] += totalAmount;
          break;
        }
      }
    }

    for (const payroll of payrollItems) {
      const res = _calculateTax(payroll, payItem, this.checkCase);

      totalsObj[contributions.tax] += res;

      if (this.checkCase("isIndividualDiff")) {
        totalsObj[contributions.gsis] += payroll?.gsis || 0;
        totalsObj[contributions.phic] += payroll?.philhealth || 0;
      }
    }

    return totalsObj;
  }

  _sumOtherPayrollData({ payrollItems, objectData }) {
    const { payItem, payrollType, jobType } = objectData;

    const totalsObj = Object.values(payrollBreakdown).reduce((acc, key) => {
      acc[key] = 0;
      return acc;
    }, {});

    console.log("payrollItems", payrollItems)

    for (const payroll of payrollItems) {
      const earnedBasic = this.checkCase("isInitialLastIp")
        ? payroll?.basicEarned
        : payroll?.earnedBasic;
      const peraAda = this.checkCase("isInitialLastIp")
        ? payroll?.peraAdaEarned
        : payroll?.earnedPeraAda;
      if (Array.isArray(earnedBasic)) {
        const basicTotal = earnedBasic
          .map((val) => parseFloat(val))
          .filter((n) => !isNaN(n))
          .reduce((acc, curr) => acc + curr, 0);
        totalsObj[payrollBreakdown.salariesWages] += basicTotal;
      } else if (!isNaN(earnedBasic)) {
        totalsObj[payrollBreakdown.salariesWages] += earnedBasic;
      }

      // Sum earnedPeraAda whether it's a number or array
      if (Array.isArray(peraAda)) {
        const peraTotal = peraAda
          .map((val) => parseFloat(val))
          .filter((n) => !isNaN(n))
          .reduce((acc, curr) => acc + curr, 0);
        totalsObj[payrollBreakdown.pera] += peraTotal;
      } else if (!isNaN(peraAda)) {
        totalsObj[payrollBreakdown.pera] += peraAda;
      }

      if (
        this.checkCase("isBasicJoAddendum") &&
        Array.isArray(payroll?.earnedForThePeriod)
      ) {
        const sum = sumArray(payroll.earnedForThePeriod);

        totalsObj[payrollBreakdown.liabilities] += sum;
      }

      if (payrollType === "Augmentation Pay") {
        const netEarned = payroll?.netEarned;
        if (!isNaN(netEarned)) {
          totalsObj[payrollBreakdown.liabilities] += netEarned;
        }
      } else if (this.checkCase("isIndividualAPBackpay")) {
        const earnedForPeriod = payroll?.earnedForThePeriod;
        const sum = sumArray(payroll.earnedForThePeriod);

        totalsObj[payrollBreakdown.liabilities] += sum;
      } else if (this.checkCase("isIndividualJoBackpay")) {
        const sumGratuityPay = sumArray(payroll?.gratuityPay, true) || 0;
        const earned = payroll?.totalEarned - sumGratuityPay;
        const sum = sumArray(earned, true);
        totalsObj[payrollBreakdown.liabilities] += sum;
        totalsObj[payrollBreakdown.gratuityPay] += sumGratuityPay;
      } else if (this.checkCase("isIndividualJoInitial")) {
        const earned = payroll?.totalEarned - (payroll?.gratuityPay ?? 0);
        const gratuityPay = payroll?.gratuityPay;
        totalsObj[payrollBreakdown.liabilities] += earned;
        totalsObj[payrollBreakdown.gratuityPay] += gratuityPay;
      } else if (this.checkCase("isBasicJoSalary")) {
        const earnedForPeriod = payroll?.earnedForThePeriod;
        totalsObj[payrollBreakdown.liabilities] += earnedForPeriod;
      } else if (payItem === "Initial RATA") {
        const rataAllowance = payroll?.rataAllowance;
        totalsObj[payrollBreakdown.pera] += rataAllowance;
      } else if (this.checkCase("isIndividualJoInitial")) {
        const totalEarned = payroll?.earnedForThePeriod;
        totalsObj[payrollBreakdown.liabilities] += totalEarned;
      } else if (this.checkCase("isIndividualDiff")) {
        const totalAmtEarned = payroll?.totalAmtEarned;
        const myDiff = payroll?.myDiff;
        const yeDiff = payroll?.yeDiff;
        totalsObj[payrollBreakdown.salariesWages] += totalAmtEarned;
        totalsObj[payrollBreakdown.midYear] += myDiff;
        totalsObj[payrollBreakdown.yearEnd] += yeDiff;
      } else if (payItem === "20% Monthly Premium") {
        const totalEarned = payroll?.twentyPercentEarned;

        totalsObj[payrollBreakdown.liabilities] += totalEarned;
      }
    }
    if (payrollType === "Augmentation Pay") {
      return { "Trust Liabilities": totalsObj[payrollBreakdown.liabilities] };
    } else if (
      this.checkCase("isIndividualAPBackpay") ||
      (payrollType === "Basic Pay" && jobType === "Job Order") ||
      this.checkCase("isIndividualJoInitial")
    ) {
      const gratuityPay = totalsObj[payrollBreakdown.gratuityPay];
      return {
        "Trust Liabilities": totalsObj[payrollBreakdown.liabilities],
        ...(gratuityPay !== 0 ? { "Gratuity Pay": gratuityPay } : {}),
      };
    } else if (payItem === "Initial RATA") {
      return {
        "Representation Allowance/Transportation Allowance":
          totalsObj[payrollBreakdown.pera],
      };
    }

    return totalsObj;
  }

  calculateNetTotal(
    contributionLists,
    otherPayrollData,
    titleAccLists,
    objectData,
    categorized
  ) {
    if (
      objectData?.payrollType === "Special Payroll" &&
      objectData?.payItem !== "20% Monthly Premium"
    ) {
      const debitTotal = categorized?.debit.reduce(
        (sum, item) => sum + Number(item?.amount || 0),
        0
      );

      const creditTotal = categorized?.credit.reduce(
        (sum, item) => sum + Number(item?.amount || 0),
        0
      );

      const netTotal = debitTotal - creditTotal;

      return {
        netTotal,
      };
    }

    const contributionTotal = Object.values(contributionLists).reduce(
      (sum, value) => sum + Number(value || 0),
      0
    );

    const titleAccTotal = (titleAccLists || []).reduce(
      (sum, item) => sum + Number(item?.amount || 0),
      0
    );

    const otherPayrollTotal = Object.values(otherPayrollData).reduce(
      (sum, value) => {
        if (typeof value === "string") {
          return (
            sum +
            value
              .split(",")
              .map((v) => parseFloat(v) || 0)
              .reduce((a, b) => a + b, 0)
          );
        }
        return sum + (Number(value) || 0);
      },
      0
    );

    const allDeductions = titleAccTotal + contributionTotal;

    const netTotal = otherPayrollTotal - allDeductions;

    return {
      netTotal,
    };
  }

  getBackpayDate(backpay) {
    if (!Array.isArray(backpay)) return "";

    const allMonthYears = [];

    backpay.forEach((item) => {
      let hasValidNetAmount = false;

      if (Array.isArray(item.netAmount)) {
        item.netAmount.forEach((entry) => {
          if (typeof entry === "string" && entry.includes(" - ")) {
            const [monthYear] = entry.split(" - ");
            allMonthYears.push(monthYear);
            hasValidNetAmount = true;
          }
        });
      }

      // Fallback to selectedDate only if netAmount has no valid strings
      if (!hasValidNetAmount && Array.isArray(item.selectedDate)) {
        allMonthYears.push(...item.selectedDate);
      }
    });

    if (allMonthYears.length === 0) return "";

    const parsedDates = allMonthYears
      .map((str) => new Date(str + " 1"))
      .filter((date) => !isNaN(date));

    if (parsedDates.length === 0) return "";

    const earliest = new Date(Math.min(...parsedDates));
    const latest = new Date(Math.max(...parsedDates));

    const formatFull = (date) =>
      date.toLocaleString("default", { month: "long", year: "numeric" });

    return `${formatFull(earliest)}, ${formatFull(latest)}`;
  }

  calculateNetPayTotal(payrollData) {
    let total = 0;

    for (const item of payrollData || []) {
      const netAmount = item?.netAmount;

      if (Array.isArray(netAmount)) {
        for (const entry of netAmount) {
          let amount = 0;

          if (typeof entry === "string" && entry.includes("-")) {
            // safe to split only if it's a string
            const [, amountStr] = entry.split("-");
            amount = parseFloat(amountStr?.trim());
          } else if (typeof entry === "number") {
            amount = entry;
          }

          if (!isNaN(amount)) {
            total += amount;
          }
        }
      } else {
        const amount = parseFloat(netAmount);
        if (!isNaN(amount)) {
          total += amount;
        }
      }
    }

    return total;
  }

  getDynamicLabel(backPay, object, payrollData, contributions, titleAccLists) {
    const payrollItem = payrollData[0];
    const backPayData = backPay?.[0];

    const { payrollType, payItem, jobType, payrollCode } = object;

    let labelLists = {};
    if (
      payrollType === "Individual Payroll" &&
      payItem !== "Initial Salary(AP)" &&
      payItem !== "Last Salary(AP)" &&
      jobType === "Job Order" &&
      payItem !== "Last Salary"
    ) {
      const employee = payrollData[0]?.employee;
      const fullName = `(${employee?.agency ?? ""}) ${
        employee?.surname ?? ""
      } ${employee?.Firstname ?? ""} ${employee?.Middlename ?? ""}`;
      labelLists.payeeLbl = fullName;
      labelLists.payrollCodeLbl = "PAYROLL CODE:";
      labelLists.payrollCodeName = payrollCode;
      labelLists.addressLbl = employee?.accountNumber ?? "";
      labelLists.positionLbl = jobType === "Job Order" ? employee?.nonRegPosition?.positionTitle ?? "" : employee?.position?.position_title ?? "";
    } else if (jobType === "Job Order" && payItem === "Last Salary") {
      const employee = backPay[0]?.employee;

      const fullName = `(${employee?.agency ?? ""}) ${
        employee?.surname ?? ""
      } ${employee?.Firstname ?? ""} ${employee?.Middlename ?? ""}`;
      labelLists.payeeLbl = fullName;
      labelLists.payrollCodeLbl = "PAYROLL CODE:";
      labelLists.payrollCodeName = payrollCode;
      labelLists.addressLbl = employee?.accountNumber ?? "";
      labelLists.positionLbl = employee?.nonRegPosition?.positionTitle ?? "";
    } else if (
      (payrollType === "Individual Payroll" &&
        (payItem === "Initial Salary(AP)" || payItem === "Last Salary(AP)")) ||
      (jobType === "Job Order" && isBackPayItem(payItem))
    ) {
      const employee = backPay[0]?.employee;
      const fullName = `(${employee?.agency ?? ""}) ${
        employee?.surname ?? ""
      } ${employee?.Firstname ?? ""} ${employee?.Middlename ?? ""}`;
      labelLists.payeeLbl = fullName;
      labelLists.payrollCodeLbl = "PAYROLL CODE:";
      labelLists.payrollCodeName = payrollCode;
      labelLists.addressLbl = employee?.accountNumber ?? "";
      labelLists.positionLbl =
        jobType === "Job Order"
          ? employee?.nonRegPosition?.positionTitle ?? ""
          : employee?.position?.position_title ?? "";
    } else if (
      (payrollType === "Individual Payroll" &&
        (payItem === "Last Salary" || payItem === "Initial Salary")) ||
      payItem === "Salary Differential (Basic)" ||
      payItem === "Initial RATA"
    ) {
      const employee = payrollData[0]?.employee;

      const fullName = `(${employee?.agency ?? ""}) ${
        employee?.surname ?? ""
      } ${employee?.Firstname ?? ""} ${employee?.Middlename ?? ""}`;
      labelLists.payeeLbl = fullName;
      labelLists.payrollCodeLbl = "PAYROLL CODE:";
      labelLists.payrollCodeName = payrollCode;
      labelLists.addressLbl = employee?.accountNumber ?? "";
      labelLists.positionLbl = employee?.position?.position_title;
    } else if (
      payrollType === "Individual Payroll" &&
      jobType === "Job Order" &&
      payItem === "Last Salary"
    ) {
      const employee = backPay[0]?.employee;
      const fullName = `(${employee?.agency ?? ""}) ${
        employee?.surname ?? ""
      } ${employee?.Firstname ?? ""} ${employee?.Middlename ?? ""}`;
      labelLists.payeeLbl = fullName;
      labelLists.payrollCodeLbl = "PAYROLL CODE:";
      labelLists.payrollCodeName = payrollCode;
      labelLists.addressLbl = employee?.accountNumber ?? "";
      labelLists.positionLbl = employee?.nonRegPosition?.positionTitle ?? "";
    } else if (payrollType === "Augmentation Pay") {
      labelLists.payrollCodeLbl = "";
      labelLists.payeeLbl = (
        <>
          LAND BANK OF THE PHILIPPINES
          <br />
          (For the Accounts of Officials & Employees of this Bureau)
        </>
      );
      labelLists.salaryTypeLbl = "AUGMENTATION OF SALARIES";
      labelLists.addressLbl = payrollCode;
    } else {
      const isBasicJo = payrollType === "Basic Pay" && jobType === "Job Order";

      labelLists.payrollCodeLbl = "";
      labelLists.payeeLbl = (
        <>
          LAND BANK OF THE PHILIPPINES
          <br />
          (For the Accounts of Officials & Employees of this Bureau)
        </>
      );
      labelLists.salaryTypeLbl = isBasicJo ? "SALARIES" : "SALARIES AND PERA/ADA";
      labelLists.addressLbl = payrollCode;
    }

    if (
      jobType !== "Job Order" &&
      (payItem === "Initial Salary" || payItem === "Last Salary")
    ) {
      const employee = payrollData[0]?.employee;
      labelLists.payComputationLbl = "BASIC PAY COMPUTATION";
      labelLists.salaryTypeLbl = `${payItem.toUpperCase()} & PERA/ADA`;
      labelLists.salaryLbl = payrollData[0]?.gross || extractSalary(employee?.salaryGrade ?? "0");
      const netProratedBasic = calculate(payrollItem?.proratedRate, [
        { type: "subtract", value: payrollItem?.minsBasic },
      ]);

      const netProratedPera = calculate(payrollItem?.proratedPera, [
        { type: "subtract", value: payrollItem?.minsPera },
      ]);
      const totalAmntEarned = calculate(netProratedBasic, [
        { type: "add", value: netProratedPera },
      ]);

      const netPay = calculate(totalAmntEarned, [
        { type: "subtract", value: contributions["Due to BIR"] },
        { type: "subtract", value: contributions["Due to GSIS"] },
        { type: "subtract", value: contributions["Due to Pagibig"] },
        { type: "subtract", value: contributions["Due to Philhealth"] },
      ]);

      labelLists.proratedBasic = payrollItem?.proratedRate;
      labelLists.proratedPera = payrollItem?.proratedPera;
      labelLists.basic = payrollItem?.basic;
      labelLists.pera = payrollItem?.pera;
      labelLists.netProratedBasic = netProratedBasic;
      labelLists.netProratedPera = netProratedPera;
      labelLists.totalAmntEarned = totalAmntEarned;
      labelLists.netPay = netPay;
    } else if (jobType === "Job Order" && payItem === "Last Salary") {
      const employee = backPay[0]?.employee;
      labelLists.salaryTypeLbl = payItem.toUpperCase();
      labelLists.salaryLbl = extractSalary(
        employee?.nonRegPosition?.montlhyRate ?? "0"
      );
      labelLists.payComputationLbl = "LAST SALARY COMPUTATION";
    } else if (jobType === "Job Order" && payItem === "Initial Salary") {
      const employee = payrollData[0]?.employee;
      labelLists.salaryTypeLbl = payItem.toUpperCase();
      labelLists.positionLbl = employee?.nonRegPosition?.positionTitle ?? "";
      labelLists.salaryLbl = extractSalary(
        employee?.nonRegPosition?.montlhyRate ?? "0"
      );
      labelLists.payComputationLbl = "INITIAL SALARY COMPUTATION";
    } else if (payrollType === "Basic Pay" && payItem === "Addendum Payroll") {
      labelLists.payComputationLbl = "SALARIES AND PERA/ADA";
    } else if (
      payItem === "Initial Salary(AP)" ||
      payItem === "Last Salary(AP)"
    ) {
      const employee = backPay[0]?.employee;
      labelLists.payComputationLbl = "AUGMENTATION PAY COMPUTATION";
      labelLists.salaryLbl = extractSalary(employee?.salaryGrade ?? "0");
      labelLists.overpayment = payrollItem?.overpayment ?? 0;
      labelLists.flagRaising = payrollItem?.flagRaising ?? 0;
    } else if (
      payrollType === "Individual Payroll" &&
      payItem === "Salary Differential (Basic)"
    ) {
      labelLists.salaryTypeLbl = "Salary Differential";
      labelLists.totalAmntEarned = payrollItem?.totalAmtEarned;
      labelLists.myDiff = payrollItem?.myDiff;
      labelLists.yeDiff = payrollItem?.yeDiff;
    }

    if (payItem === "Initial Salary(AP)") {
      const label = "Initial";
      const employee = backPay[0]?.employee;
      console.log("backPayData", backPayData);
      const daysEarnedTotal = sumArray(backPayData?.daysEarned);
      const latesIncurred = sumArray(backPayData?.latesUtDeduction);
      const overpayment = sumArray(backPayData?.overpayment);
      const flagRaising = sumArray(backPayData?.flagRaising);

      console.log("daysEarnedTotal", daysEarnedTotal);
      console.log("paycode", employee?.payCode);

      const totalAmntEarned = calculateArray(employee?.payCode, [
        { type: "/", value: 22 },
        { type: "*", value: backPayData?.daysEarned },
        { type: "-", value: backPayData?.latesUtDeduction },
        { type: "-", value: backPayData?.overpayment },
        { type: "-", value: backPayData?.flagRaising },
      ]);

      const amtEarned = sumArray(totalAmntEarned);

      const netPay = calculate(amtEarned, [
        { type: "subtract", value: contributions["Due to BIR"] },
      ]);

      labelLists.salaryTypeLbl = `${label.toUpperCase()} AUGMENTATION OF SALARY`;
      labelLists.totalAmntEarned = amtEarned;
      labelLists.daysEarned = daysEarnedTotal;
      labelLists.netPay = netPay;
      labelLists.latesIncurred = latesIncurred;
      labelLists.overpayment = overpayment;
      labelLists.flagRaising = flagRaising;
    } else if (payItem === "Last Salary(AP)") {
      const employee = backPay[0]?.employee;
      const daysEarnedTotal = sumArray(backPayData?.daysEarned);
      const latesIncurred = sumArray(backPayData?.latesUtDeduction);
      const overpayment = sumArray(backPayData?.overpayment);
      const flagRaising = sumArray(backPayData?.flagRaising);

      const label = "Last";

      const totalAmntEarned = calculateArray(employee?.payCode, [
        { type: "/", value: 22 },
        { type: "*", value: backPayData?.daysEarned },
        { type: "-", value: backPayData?.latesUtDeduction },
        { type: "-", value: backPayData?.overpayment },
        { type: "-", value: backPayData?.flagRaising },
      ]);
      const amtEarned = sumArray(totalAmntEarned);

      const netPay = calculate(amtEarned, [
        { type: "subtract", value: contributions["Due to BIR"] },
      ]);

      labelLists.salaryTypeLbl = `${label.toUpperCase()} AUGMENTATION OF SALARY`;
      labelLists.totalAmntEarned = amtEarned;
      labelLists.daysEarned = daysEarnedTotal;
      labelLists.netPay = netPay;
      labelLists.latesIncurred = latesIncurred;
      labelLists.overpayment = overpayment;
      labelLists.flagRaising = flagRaising;
    } else if (payItem === "Initial RATA") {
      labelLists.salaryTypeLbl =
        "REPRESENTATION ALLOWANCE / TRANSPORTATION ALLOWANCE (RATA)";
    } else if (payItem === "Salary Differential (Basic)") {
      const netPay = calculate(payrollItem?.totalAmtEarned, [
        { type: "subtract", value: payrollItem?.tax },
        { type: "subtract", value: payrollItem?.gsis },
        { type: "subtract", value: payrollItem?.philhealth },
      ]);

      const withYeAndMyDiff = calculate(netPay, [
        { type: "add", value: payrollItem?.myDiff },
        { type: "add", value: payrollItem?.yeDiff },
      ]);

      labelLists.netPay = netPay;
      labelLists.withYeAndMyDiff = withYeAndMyDiff;
    }

    if (
      (payrollType === "Basic Pay" || payrollType === "Augmentation Pay") &&
      payItem === "General Payroll"
    ) {
      labelLists.paymentLbl = "Payment";
    } else if (payrollType === "Basic Pay" && payItem === "Addendum Payroll") {
      labelLists.salaryTypeLbl = "SALARIES AND PERA/ADA";
      labelLists.paymentLbl = "Addendum";
    } else if (payrollType === "Basic Pay" && isAddendumBackPayItem(payItem)) {
      labelLists.paymentLbl = PAY_ITEMS.BACK_PAY;
    } else if (
      payrollType === "Individual Payroll" ||
      payItem === "Newly-Hired"
    ) {
      labelLists.paymentLbl = "Payment";
    } else if (
      jobType === "Job Order" &&
      (isBackPayItem(payItem) || payItem === "Salary")
    ) {
      labelLists.paymentLbl = "Payment";
      if (isBackPayItem(payItem)) {
        labelLists.salaryTypeLbl = "BACK PAY SALARIES";
      }
    } else if (payrollType === "Special Payroll") {
      labelLists.paymentLbl = "Payment";
      labelLists.salaryTypeLbl = payItem;
    }
    return labelLists;
  }
}
export default PayrollListFormPresenter;
